import { SearchableCombobox, TSearchable } from '@/components/base/combobox'
import { useCombobox } from '@/helpers/useCombobox'
import { MaintenanceEventResult } from '@/types'
interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
}

interface ResultFieldItem {
  id: MaintenanceEventResult
  name: string
}

const values: ResultFieldItem[] = [
  { id: MaintenanceEventResult.Passed, name: 'Passed' },
  { id: MaintenanceEventResult.Failed, name: 'Failed' },
  { id: MaintenanceEventResult.Quarantined, name: 'Quarantined' },
]

export const Selector = ({ value, onChange, invalid }: Props) => {
  const { items } = useCombobox<ResultFieldItem>({
    pageInfo: undefined,
    querySelected: undefined,
    queryCollection: values,
    buildSearchable: item => item
  })

  return (
    <SearchableCombobox
      data={items}
      fetchMore={() => {}}
      includeBlank={true}
      invalid={invalid}
      loading={false}
      moreToFetch={false}
      refetch={() => { }}
      searchField=""
      value={items.find(d => d.id == value) || { id: value, name: value }}
      onChange={onChange}
    />
  )
}
